import {
  jaccardBufferedPathPairsSync,
  type JaccardBufferedPathPairInput,
  type JaccardBufferedPathPairResult,
} from './jaccard-buffered-path-pairs-sync.js'
import { runInGeoWorker } from '../workers/geo-worker-runtime.js'
import type { LngLatCoord } from '@gpx-spa/geo-domain'

function clonePairsForWorker(
  pairs: JaccardBufferedPathPairInput[]
): JaccardBufferedPathPairInput[] {
  return pairs.map((pair) => ({
    learnedPathId: pair.learnedPathId,
    googlePathId: pair.googlePathId,
    radiusMeters: pair.radiusMeters,
    learned: pair.learned.map((c) => [Number(c[0]), Number(c[1])] as LngLatCoord),
    google: pair.google.map((c) => [Number(c[0]), Number(c[1])] as LngLatCoord),
  }))
}

export async function jaccardBufferedPathPairs(
  pairs: JaccardBufferedPathPairInput[]
): Promise<JaccardBufferedPathPairResult[]> {
  if (pairs.length === 0) return []
  return runInGeoWorker({
    method: 'jaccardBufferedPathPairs',
    payload: pairs,
    cloneForWorker: clonePairsForWorker,
    onMainThread: jaccardBufferedPathPairsSync,
    debugDetail: `${pairs.length} pair(s)`,
  })
}
